import { NotesComponent } from './components/notes/notes.component';
import { NotesModalWrapperComponent } from './components/notes-modal-wrapper/notes-modal-wrapper.component';
import { AberrationCommentsComponent } from './components/aberration-comments/aberration-comments.component';

export const NotesComponents = [NotesComponent, NotesModalWrapperComponent, AberrationCommentsComponent];

export const  NotesServices = [];
